import type { FinEnvironmentName, IFinEnvironment } from './environment-types';

export const environment: IFinEnvironment = {
  name: 'comerascfeu' as FinEnvironmentName,
  production: true,
  isSaaSProject: true,
  api: {
    gatewayWSUrl: 'wss://gateway.services.scf.comeramoney.com/graphql',
    gatewayUrl: 'https://gateway.services.scf.comeramoney.com/graphql',
    SSOUrl: 'https://sso.services.scf.comeramoney.com',
    currenciesUrl: 'https://gateway.services.scf.comeramoney.com/utils/currency-config',
    userDocumentsUrl: 'https://sso.services.scf.comeramoney.com/document-signs',
    fileServerUrl: 'https://fileuploader.services.scf.comeramoney.com/files',
    instrumentsUploadTemplateUrl:
      'https://comerascfeu-public-assets.s3.eu-west-1.amazonaws.com/xslx-templates/bulk_instrument_upload.xlsx',
    customersBulkUploadTemplateUrl:
      'https://comerascfeu-public-assets.s3.eu-west-1.amazonaws.com/xslx-templates/bulk_customer_upload_template.xlsx',
    leadsBulkUploadTemplateUrl:
      'https://comerascfeu-public-assets.s3.eu-west-1.amazonaws.com/xslx-templates/self_onboarding_upload_template.xlsx',
    uploadingLeadsForSelfOnboardingTemplateUrl:
      'https://comerascfeu-public-assets.s3.eu-west-1.amazonaws.com/xslx-templates/self_onboarding_upload_template.xlsx',
    bankHolidaysUploadTemplateUrl:
      'https://comerascfeu-public-assets.s3.eu-west-1.amazonaws.com/xslx-templates/bulk_bank_holidays_upload_template.xlsx',
    integrationDocumentationUrl: 'https://gateway.services.scf.comeramoney.com/v1/api/integration-docs',
    fullAPIReferenceUrl: 'https://gateway.services.scf.comeramoney.com/v1/api/docs',
    rateLimiterHeader: '',
    maxUserInactivityMinutes: 60,
  },
  platform: {
    title: 'Comera Money Platform',
    company: 'Comera Money',
    displayUrl: 'scf.comeramoney.com',
    companyAddress: 'Comera Pay LLC, PO Box 130666, Masdar City, Abu Dhabi',
    logo: {
      default: { src: 'assets/logo/logo.svg', width: 113, height: 56 },
      login: { src: 'assets/logo/logo-login.svg', width: 100, height: 100 },
      collapsedSidebar: { src: 'assets/logo/logo-sidebar-collapsed.svg', width: 48, height: 60 },
    },
    faviconUrl: 'assets/favicon/favicon.ico',
    email: 'product.scf@comeramoney.com',
    helpLink: 'https://support.finverity.com/kb/guide/en/landing-page-Z0IncfcZbi/Steps/3514119',
    isSsoAuthEnabled: false,
    locale: 'en-GB',
    azureIntegrationPdfUrl:
      'https://comerascfeu-public-assets.s3.eu-west-1.amazonaws.com/Finverity%20-%20Azure%20integration.pdf',
    showHandEmojiInDashboard: false,
  },
  sentry: {
    enabled: false,
    dsn: 'https://aea0ee4f0b1b49f6b18d5d15aeda5420@o4504480764723200.ingest.sentry.io/4504519285538816',
  },
  firebase: {
    appName: 'FINVERITY',
    apiKey: 'AIzaSyAP2IlVBE8E3ItzeX6e9FkH0GH2mT9GClc',
    authDomain: 'finverity-staging.firebaseapp.com',
    databaseURL: 'https://finverity-staging.firebaseio.com',
    projectId: 'finverity-staging',
    storageBucket: 'finverity-staging.appspot.com',
    messagingSenderId: '1037880577124',
    appId: '1:1037880577124:web:3dd9469e015bef2ffe2371',
    measurementId: 'G-M90YF15270',
  },
  stonly: {
    enabled: true,
    widgetId: '848e9ac1-cbfc-11ee-bc11-06cb0cb2a85e',
  },
  userSnap: {
    enabled: true,
    GlobalAPIKey: '8d1ac1d2-2145-492b-9ad8-62f358f85d2d',
    ProjectAPIKey: 'c05d893e-8ef2-4a17-8dd5-f1b483d4c6f5',
  },
};
